import { historyUtil } from '../history-plugin/history';
import { regHook, getHooks, unRegHook, HookType, getSyncHook } from '../js-api-tools';
import { weappSDK } from '../sdk';
import { getSecondPathUrl } from './utils';

export type OpenType = 'open' | 'href' | 'route' | 'iframe' | 'form' | 'weappSDK';

class WinowOpen {
  private originOpen: any;
  plugins = [];
  typeList: OpenType[] = ['open', 'href', 'route', 'iframe', 'form', 'weappSDK'];
  webOpen: any;

  /**
   *  注册钩子
   * @param fn
   * @returns
   */
  regOpenPlugin = (fn: Function, module: OpenType = 'open', priority = 0) => {
    if (typeof fn !== 'function') {
      return;
    }
    regHook('@weapp/utils', module, fn, priority);
  };
  /**
   *  移除钩子
   */
  removeOpenPlugin = (fn: Function | HookType, module: OpenType = 'open') => {
    return unRegHook('@weapp/utils', module, fn);
  };

  /**
   *
   * @param fn 钩子函数
   * @param priority 优先级
   * @returns
   */

  regAllOpenPlugin = (fn: Function, priority = 0) => {
    if (typeof fn !== 'function') {
      return;
    }
    this.typeList.forEach((module: OpenType) => {
      this.regOpenPlugin(fn, module, priority);
    });
  };

  /**
   *
   * @param fn 钩子函数
   * @returns
   */
  removeAllOpenPlugin = (fn: Function) => {
    if (typeof fn !== 'function') {
      return;
    }
    this.typeList.forEach((module: OpenType) => {
      unRegHook('@weapp/utils', module, fn);
    });
  };

  /**
   *  获取已注册的函数
   * @returns
   */
  getOpenPlugin = (module: OpenType = 'open') => {
    return getHooks('@weapp/utils', module);
  };
  /**
   * 销毁
   */
  destoryOpen = () => {
    if (this.originOpen) {
      window.open = this.originOpen;
    }
  };

  // 替换window.open方法
  replaceOpen = () => {
    const originOpen = window.open;
    this.originOpen = originOpen;
    this.webOpen = (...args: any[]) => {
      // 每次调用的时候获取当前注册的钩子
      const url = args[0];
      if (url) {
        const hooks = getSyncHook('@weapp/utils', 'open');
        if (hooks) {
          args[0] = hooks(url);
        }
      }
      return originOpen(...args);
    };
    window.open = this.webOpen;
  };

  /**
   * 执行sdk方法
   * @param command 方法名称
   * @param params 执行方法传入的参数
   * @returns Promise<any>
   */
  sdkOpen = (params: any) => {
    const { execType = 'openLink', command, ...otherParams } = params;

    if (otherParams.url) {
      const hooks = getSyncHook('@weapp/utils', 'weappSDK');
      if (hooks) {
        otherParams.url = hooks(otherParams.url);
      }
    }
    if (execType === 'openLink') {
      return weappSDK.openLink(otherParams);
    } else if (command) {
      return weappSDK.exec(command, otherParams);
    }
  };

  // 执行open方法
  windowOpen = (params: any) => {
    if (params.url) {
      const hooks = getSyncHook('@weapp/utils', 'open');
      if (hooks) {
        params.url = hooks(params.url);
      }
    }
    const targetWindow = window.open(params.url, params.name, params.specs)
    // 注册回调钩子
    if(params.hookFn && typeof params.hookFn === 'function') {
      this.setOpenerHook(params.hookFn, targetWindow);
    }
    return targetWindow
  };

  // 路由push
  routerPush = (params: any) => {
    if (params.url) {
      const hooks = getSyncHook('@weapp/utils', 'router');
      if (hooks) {
        params.url = hooks(params.url);
      }
    }
    return historyUtil.push(params.url, params?.state);
  };

  openHref = (params: any) => {
    const hooks = getSyncHook('@weapp/utils', 'href');
    if (hooks) {
      params.url = hooks(params.url);
    }
    window.location.href = params.url;
  };

  exec = (params: any) => {
    const { type, ...otherParams } = params;
    if (type === 'href') {
      this.openHref(otherParams);
    } else if (type === 'open') {
      this.windowOpen(otherParams);
    } else if (type === 'route') {
      this.routerPush(otherParams);
    } else if (type === 'weappSDK') {
      this.sdkOpen(otherParams);
    } else if (type === 'openerHook') {
      const openerHook = this.openerHook
      openerHook(...((otherParams.args || [window]) as Parameters<typeof openerHook>));
    }
  };

  // 注册回调钩子
  setOpenerHook = (hookFn: Function, targetWindow: any = window) => {
    const hookName = `_openerHook_${new Date().getTime()}`;
    if (!window._openerHookFns) {
      window._openerHookFns = {};
    }
    // A页面注册打开时的回调函数
    window._openerHookFns[hookName] = hookFn;
    targetWindow.name = hookName;
  
    return hookName;
  };

  // 触发回调钩子
  openerHook = (win: any, ...args: any[]) => {
    let targetWindow: any = null;
    if (win._openerHookFns?.[win.name]) {
      targetWindow = win;
    } else if (win.top?._openerHookFns?.[win.name]) {
      targetWindow = win.top as any;
    } else {
      targetWindow = win;
      while (!!targetWindow && !targetWindow._openerHookFns?.[win.name]) {
        targetWindow = targetWindow.opener;
      }
    }
    targetWindow?._openerHookFns?.[win.name](win, ...args);
  }
}

const webOpenSDK = new WinowOpen();

const handleSecondPath = (url: string) => {
  if (!url) return;

  const newUrl = getSecondPathUrl(url);
  if (newUrl) {
    return newUrl;
  } else {
    return url;
  }
};

webOpenSDK.regAllOpenPlugin(handleSecondPath);

const publicUrl = window.publicUrlstatic || window.publicUrl || '';
const apiPublicUrl = window.publicUrlapi || window.publicUrl || '';
// 目前只有二级路径下会替换window.open方法 其它不影响
if (publicUrl || apiPublicUrl) {
  // 二级路径变量处理 兜底 window.open 场景
  webOpenSDK.replaceOpen();
}

export { webOpenSDK, getSecondPathUrl, handleSecondPath };
